import { render, staticRenderFns } from "./donation-form.vue?vue&type=template&id=72559a4d&"
import script from "./donation-form.vue?vue&type=script&lang=js&"
export * from "./donation-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports